<template>
  <div class="pad">
    <b-row :class="'hidkey_' + hotel.id">
      <b-col class="pad__column pad__column--first" cols="12" lg="3">
        <div class="pad__image-wrap" :style="'background-image:url(\'/assets/images/common/statics/room_placeholder.png\')'">
          <div
            class="pad__image"
            :style="`background-image:url(${hotel.accommodations_details.image_url})`"
          >
            <span class="pad__image-corner"></span>
          </div>
        </div>
      </b-col>
      <b-col class="pad__column pad__column--second" cols="12" lg="9">
        <b-row class="pad__wrap">
          <b-col lg="8" xl="9" class="pad__column pad__column--first">
            <div class="pad__head">
              <h2 class="pad__head-name">
                <div class="icon" v-if="hotel.accommodations_details.preferred">
                  <vb-icon
                    class="pad__head-icon pad__head-icon--like"
                    v-b-popover.hover.top="'Pensato per offrire un ottimo servizio e un buon rapporto qualità-prezzo.'"
                    :name="'like'"
                    :color="'f8af3c'"
                    :size="15"
                  />
                </div>                
                <div class="text">
                  {{ hotel.accommodations_details.name }}
                </div>
              </h2>
              <div class="pad__head-star" v-if="hotel.accommodations_details.stars">
                <b-form-rating
                  no-border inline readonly
                  size="sm"
                  variant="secondary"
                  :value="hotel.accommodations_details.stars"
                />
              </div>
              <p class="pad__head-category" v-if="hotel.accommodations_details.category">
                {{ hotel.accommodations_details.category }}
              </p>
            </div>
            <p class="pad__address">
              <span class="pad__address-map" @click="$emit('toggle-map')">
                <vb-icon :name="'pin'" :color="sass('info')" :size="12" class="mr-1" />
                {{ hotel.accommodations_details.city }}
              </span>
              <span class="pad__address-proximity" v-if="hotel.accommodations_details.proximity_distance"
                v-b-popover.hover.right="'La distanza è in linea d’aria. Il percorso reale potrebbe essere diverso.'"
              >
                <vb-icon :name="'flag'" :color="sass('secondary')" :size="12" class="mr-1" />
                {{ round(hotel.accommodations_details.proximity_distance, 1) }} km dal centro di {{ last_search_location.name }}
                <vb-icon class="ml-1" :name="'info'" :color="sass('secondary')" :size="14" />
              </span>
            </p>
            <p class="pad__abstract">
              <span class="pad__abstract-room">{{ hotel.products[0].room_name }}</span>
              <pad-info
                :rate_amenities="[]"
                :cancellation="hotel.products[0].policies.cancellation"
              />
              <pad-occupancy
                :nights="nights"
              />
            </p>
            <div class="pad__push">
              <template v-for="(amenity, amenity_index) in accommodations_amenities">
                <div
                  class="pad__push-btn"
                  v-if="amenity_index < 2 && get_amenities(amenity).visible"
                  :key="_uid+'amenities'+amenity+amenity_index"
                >
                  <vb-icon
                    class="pad__push-icon"
                    v-b-popover.hover.top="get_amenities(amenity).name"
                    :name="get_amenities(amenity).icon"
                    :color="sass('black')"
                    :size="16"
                  />
                </div>
              </template>
              <div
                class="pad__push-btn"
                v-b-modal="_uid+'modal_amenities'"
                v-if="accommodations_amenities.length > 2"
              >
                <vb-icon
                  class="pad__push-icon"
                  :name="'dotted'"
                  :color="sass('black')"
                  :size="16"
                />
              </div>
              <vb-modal
                :vb_options="{
                  id: _uid+'modal_amenities',
                  body_class: 'pad__modal',
                  title: 'Principali Servizi',
                  size: 'md',
                  centered: true,
                  hide_footer: true
                }"
              >
                <div class="pad__modal-wrap">
                  <template v-for="(amenity, amenity_index) in accommodations_amenities">
                    <div class="pad__modal-item" v-if="amenity" :key="_uid+'amenities'+amenity_index">
                      <vb-icon
                        class="pad__modal-item_icon"
                        :name="get_amenities(amenity).icon"
                        :color="sass('primary')"
                        :size="16"
                      />
                      <span class="pad__modal-item_label">{{ get_amenities(amenity).name }}</span>
                    </div>
                  </template>
                </div>
              </vb-modal>
            </div>
          </b-col>
          <b-col lg="4" xl="3" lass="pad__column pad__column--second price">
            <score :rating="number(hotel.accommodations_details.salabam_score)" />
            <div class="pad__price-info mt-2">
              <div class="pad__deal" v-if="tags.length">
                <b-badge
                  v-for="tag in tags"
                  :key="tag.label"
                  :variant="tag.variant"
                >
                  <span>{{ tag.label }}</span>
                </b-badge>
              </div>
              <div class="pad__price-night" v-if="nights > 1">
                <vb-icon class="pad__price-night-icon" :name="'euro'" :color="sass('gray-600')" :size="10" />
                &nbsp;
                <span class="pad__price-night-value">{{ get_price_per_night(price, nights) }}</span>/notte
              </div>              
            </div>
            <div class="pad__price">
              <div class="pad__price-wrap">
                <div v-if="public_price && price !== public_price" class="pad__price-discount mr-1">
                  € {{ get_formatted_value(public_price) }}
                </div>
                <span class="pad__price-value">€ {{ get_formatted_value(price) }}</span>
              </div>
              <span class="pad__price-tax">include gestione e assistenza</span>
            </div>
            <div class="pad__cta">
              <custom-link
                :before_navigation="() => {
                  this.$store.commit('livebkv3/selected_hotel', hotel)
                }"
                :route_name="'detail'"
                :css_class="'d-block'"
                :as_default="get_config('guiSettings.openDetailNewTab', false)"
              >
                <template #content>
                  <vb-button
                    class="shadow"
                    :vb_options="{
                      text: 'Vedi disponibilità',
                      variant: 'info',
                      size: 'sm'
                    }"
                  />
                </template>
              </custom-link>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { round, format } from 'mathjs'
import { get_amenities } from '@bookingv3/resources'
import { get_live_price_no_tax, get_public_price } from "@src/sites/bookingv3/utilities"
import { decode_parameters } from '@utilities'
import Score from "@bookingv3/components/atoms/score.vue"
import PadOccupancy from "@bookingv3/components/atoms/pad-occupancy.vue"
import PadInfo from "@bookingv3/components/atoms/pad-info.vue"
import { divide, number } from 'mathjs'
import { mapState } from 'vuex'

export default {
  name: "pad",

  components: {
    'score': Score,
    'pad-occupancy': PadOccupancy,
    'pad-info': PadInfo,
  },

  props: {
    hotel: Object,
    nights: Number,
  },

  data() {
    return {
      last_search_location: '',
    }
  },

  computed: {
    // module state keys
    ...mapState(['occupancy']),

    ...mapState(
      'livebkv3', [
        'location',
        'current_search',
      ]
    ),

    accommodations_amenities() {
      const hotel = this.hotel.accommodations_details,
            amenities = {
              has_accessibility: hotel.has_accessibility,
              has_business_center: hotel.has_business_center,
              has_charging_station: hotel.has_charging_station,
              has_children_services: hotel.has_children_services,
              has_parking: hotel.has_parking,
              has_pool: hotel.has_pool,
              has_restaurant: hotel.has_restaurant,
              has_spa: hotel.has_spa,
              has_kitchen: hotel.has_kitchen,
              pets_allowed: hotel.pets_allowed,
            }

      return Object.keys(amenities).filter(key => amenities[key])
    },

    price(){
      return get_live_price_no_tax(this.hotel.products[0].price) // live_price senza tasse di soggiorno
    },

    public_price() {
      if (this.hotel.products[0].deal == undefined) return null
      return get_public_price(this.hotel.products[0].deal.public_price)
    },

    tags() {
      const tags = (this.hotel.products[0].deal && this.hotel.products[0].deal.tags) || []

      return [
        {
          show: tags.length > 0,
          variant: 'primary',
          label: 'Ottimo prezzo!'
        },
        {
          show: tags.includes('black_friday'),
          variant: 'dark',
          label: 'Black Friday!'
        }
      ].filter(tag => tag.show)
    }

  },

  created() {
    this.divide = divide
    this.round = round
    this.number = number
    this.format = format
    this.get_amenities = get_amenities
  },

  mounted() {
    this.last_search_location = decode_parameters(this.current_search).suggestion
  },

  watch: {},

  methods: {
    get_formatted_value(value) {
      const formatted = format(value, {notation: 'fixed', precision: 2})
      return formatted.replace('.', ',')
    },

    get_price_per_night(price, nights) {
      const avg = round(divide(price, nights), 2)
      return this.get_formatted_value(avg)
    }
  },
}
</script>

<style lang="scss" scoped>

  $booking: #1F3C95;

  .price {
    padding: 0 !important;
  }

  .pad {
    $this: &;
    position: relative;

    &__column {

      &--first {
        @at-root #{$this}__wrap & {
          @include media-breakpoint-up(lg) {
            padding-left: 0;
          }
        }
      }

      &--first, &--second {
        position: static !important;
      }

      &--second {
        &.price {
          text-align: right;
        }
      }
    }

    &__image {
      min-height: 300px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      border-radius: 5px;
      clip-path: polygon(0% 0%, 100% 0%, 100% 102%, 85% 84%, 0 84%);
      position: relative;
      z-index: 1;

      &-wrap {
        @extend .pad__image;
        height:100%;
        width:100%;
      }

      @include media-breakpoint-up(lg) {
        clip-path: polygon(0 0, 101% 0, 91% 23%, 91% 100%, 0% 101%);
        min-height: 100%;
      }

      // trick angolo smussato
      &-corner {
        width: 30px;
        height: 30px;
        overflow: hidden;
        position: absolute;
        left: 0;
        bottom: 16%;
        z-index: 1;
        transform: scaleX(-1);

        @include media-breakpoint-up(lg) {
          left: auto;
          right: 9%;
          bottom: 0;
          transform: scaleX(1);
        }

        &:before {
          content: "";
          width: 200%;
          height: 200%;
          position: absolute;
          border-radius: 7px;
          bottom: 0;
          right: 0;
          box-shadow: 50px 50px 0 0 $vb-body-bg;
        }
      }
    }

    &__wrap {
      background-color: $white;
      margin-top: -40px;
      padding: 15px 20px;
      border-radius: 0 10px 10px;

      @include media-breakpoint-up(lg) {
        margin-top: 0;
        //margin-left: -40px;
        //padding: 20px 50px 20px 20px;
        transform: translateX(-25px);
        padding: 20px 50px 20px 20px;
      }
    }

    &__head {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      @include media-breakpoint-up(lg) {
        flex-wrap: nowrap;
        position: relative;
      }

      &-icon {
        &--like {
          display: none;
          @include media-breakpoint-up(lg) {
            display: block
          }
        }
      }

      &-name {
        font-weight: $vb-font-weight-semibold;
        margin-right: 5px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 0;
        font-size: $font-size-lg;
        color: $dark;
        position: relative;

        .icon {
          position: relative;
          padding-left: 14px;
          padding-bottom: 3px;
          margin-right: -8px;
        }

        .text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 250px;
          position: relative;
          padding-left: $grid-gutter-width / 2;
        }

        &:before {
          content: "";
          width: $grid-gutter-width / 5;
          background-color: var(--secondary);
          position: absolute;
          top: 3px;
          bottom: 3px;
          left: 0;
          border-radius: $border-radius;
        }        
      }

      &-star {
        display: flex;
        margin-right: 5px;
      }

      &-category {
        color: $gray-600;
        font-size: $font-size-sm;
        position: absolute;
        z-index: 1;
        top: 10px;
        left: 10px;
        background-color: $white;
        padding: 4px 5px;
        border-radius: 5px;
        margin-bottom: 0;

        @include media-breakpoint-up(lg){
          position: static;
          background-color: transparent;
          padding: 0;
          border-radius: 0;

          &:before {
            content: "("
          }
          &:after {
            content: ")"
          }
        }
      }
    }

    &__address {
      font-size: $font-size-md;
      margin-bottom: 0.5rem;

      @include media-breakpoint-up(md){
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      &-text {
        width: 100%;
        color: $gray-800;
      } 

      &-map, &-proximity {
        display: flex;
        align-items: center;
      }

      &-map {
        font-weight: $vb-font-weight-semibold;
        color: var(--info);
        cursor: pointer;
      }

      &-proximity {
        color: var(--secondary);

        @include media-breakpoint-up(md){
          margin-left: $grid-gutter-width/3;
        }
      }
    }

    &__abstract {
      display: none;

      @include media-breakpoint-up(lg) {
        padding-left: $grid-gutter-width/3;
        border-left: 1px solid $gray-300;
        display: block;
        font-size: 14px;
        margin-bottom: 0;
        color: $gray-600;
      }

      &-room {
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        background-color: $gray-200;
        color: $gray-600;
        padding: 0 5px;
        border-radius: 5px;
        margin-bottom: 0;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 250px;

        @include media-breakpoint-up(lg){
          max-width: 350px;
        }        
      }
    }

    &__deal {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-md;
      //margin-top: $grid-gutter-width/3;
      display: flex;

      .badge {
        font-weight: $vb-font-weight-semibold;
        display: flex;
        align-items: center;
        padding: 3px 8px;
        line-height: normal;
        font-size: $font-size-sm;

        &.badge-primary {
          color: $booking !important;
          background-color: transparent !important;
        }
      }
    }

    &__price {
      margin-bottom: 5px;
      * {
        white-space: nowrap;
      }

      &-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: normal;
      }

      &-value {
        color: $booking;
        margin-left: 5px;
        font-weight: $vb-font-weight-semibold;
        font-size: 23px;

        @include media-breakpoint-up(lg) {
          //font-size: 21px;
        }
      }

      &-discount {
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        text-decoration: line-through;
        color: $danger;
        line-height: normal;
      }

      &-night {
        display: flex;
        align-items: baseline;
        justify-content: center;
        color: $gray-600;
        font-size: $font-size-sm;
      }      

      &-tax {
        display: block;
        font-size: $font-size-sm;
        color: $gray-600;
        text-align: right;
        line-height: normal;
      }

      &-info {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        justify-content: flex-end;
      }
    }

    &__cta {

      .shadow {
        margin-top: 5px;
        display: block;
        width: 100%;
        font-weight: $vb-font-weight-semibold;

        @include media-breakpoint-up(lg) {
          display: inline-block;
        }
      }

      @include media-breakpoint-up(lg) {
        text-align: right;
      }
    }

    &__push {
      display: flex;
      align-items: center;
      margin-top: 10px;
      padding: 10px 0;
      border-width: 1px 0;
      border-style: solid;
      border-color: $gray-200;
      justify-content: center;

      @include media-breakpoint-up(lg) {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: $booking;
        padding: 0 8px;
        margin-top: 0;
        flex-direction: column;
        justify-content: center;
        border-radius: 10px;
        border: none;
        overflow: hidden;
      }

      &:empty {
        display: none;

        @include media-breakpoint-up(lg) {
          width: 36px;
          background-color: $primary;
        }
      }

      &-btn {
        background-color: $vb-body-bg;
        border-radius: 50%;
        padding: 10px;
        margin-right: 10px;

        @include media-breakpoint-up(lg) {
          background-color: transparent;
          border-radius: 0;
          padding: 10px 0 0;
          margin-right: 0;
          margin-top: 10px;
          border-top: 1px solid #0a6098;
        }

        &:first-child {
          @include media-breakpoint-up(lg) {
            margin-top: 0;
            padding-top: 0;
            border-top: 0;
          }
        }

        &:last-child {
          margin-right: 0;
        }

        ::v-deep {
          // cambio colore icona desktop
          svg * {
            @include media-breakpoint-up(lg) {
              fill: $white;
            }
          }
        }
      }
    }

    &__modal {

      &-wrap {
        display: flex;
        flex-wrap: wrap;
      }

      &-item {
        display: flex;
        align-items: center;
        flex-basis: 40%;
        margin: 3px 0;

        &_icon {
          margin-right: 5px;
        }
      }
    }

    .custom-link {
      display: inline-block;
    }
  }

</style>